module.exports = __webpack_public_path__ + "img/suhai.4cca6bd8.png";